import React from 'react';
import { useTranslation } from 'react-i18next';

interface CartSummaryProps {
  subtotal: number;
  deliveryFee: number;
  loyaltyDiscount: number;
  total: number;
  currency: string;
}

export const CartSummary: React.FC<CartSummaryProps> = ({
  subtotal,
  deliveryFee,
  loyaltyDiscount,
  total,
  currency,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3 pt-4 pb-6 bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
      <div className="flex justify-between text-sm text-gray-600">
        <span>{t('cart.subtotal', 'المجموع الفرعي')}</span>
        <span className="font-medium">{subtotal.toFixed(2)} {currency}</span>
      </div>
      
      {deliveryFee > 0 && (
        <div className="flex justify-between text-sm text-gray-600">
          <span>{t('cart.delivery_fee', 'رسوم التوصيل')}</span>
          <span className="font-medium">{deliveryFee.toFixed(2)} {currency}</span>
        </div>
      )}
      
      {loyaltyDiscount > 0 && (
        <div className="flex justify-between text-sm text-purple-600 font-medium">
          <span>{t('cart.loyalty_discount', 'خصم نقاط الولاء')}</span>
          <span>-{loyaltyDiscount.toFixed(2)} {currency}</span>
        </div>
      )}
      
      <div className="flex justify-between items-center pt-3 mt-1 border-t border-dashed border-gray-200">
        <span className="font-bold text-lg text-gray-900">{t('cart.total', 'المجموع الكلي')}</span>
        <span className="font-bold text-xl text-primary">{total.toFixed(2)} {currency}</span>
      </div>
    </div>
  );
};
